b<template>
  <div class="conteudo">
    <PaginaTitulo sticky titulo="empresas" subTitulo="Gerencie suas empresas">
      <CounterNcm
        :contadorAtual="listaEmpresas.length"
        :contadorTotal="getAssinatura.qtde_empresa"
        tituloTooltipCheio="Limite de Empresas cadastrados atingido."
        tituloTooltip="Total de Empresas do Plano contratado."
        legenda="Empresas cadastradas"
      />
    </PaginaTitulo>

    <div class="empresas-container">
      <div class="form-wrapper-empresas">
        <div class="form-empresas">
          <div class="search-wrapper">
            <font-awesome-icon icon="search" />
            <div class="input-wrapper input-empresas">
              <CenarioInput
                placeholder="Pesquisar por Nome, CNPJ, CNAE ou UF"
                tipo="texto"
                :model="campoPesquisa"
                @update:model="update => (campoPesquisa = update)"
              />
            </div>
          </div>
        </div>
        <div>
          <BotaoPadrao
            arredondadoEsquerda
            nome="Adicionar"
            icone="plus"
            :click="inserirEmpresa"
            cor="azul"
            :desabilita="carregandoEmpresas"
          />
        </div>
      </div>

      <div class="paginacao-container">
        <TabelaEmpresas
          v-if="empresasFiltradas.length > 0 && !carregandoEmpresas"
          :conteudo="empresasFiltradas"
          :deleteTabela="deleteEmpresa"
          :editTabela="editModal"
          :syncTabela="atualizarDadosReceita"
          :cnaeTabela="setCnaes"
        />
        <MensagemSemResultados
          class="empresa-sem-resultado"
          v-if="empresasFiltradas.length == 0 && !carregandoEmpresas"
          :mensagem="'Nenhuma empresa encontrada.'"
        />
      </div>
      <div v-if="carregandoEmpresas === true">
        <LoadingPadraoContainer
          :fraseLoading="[
            'Carregando Empresas',
            'Aguarde um momento',
            'Consultando banco de dados'
          ]"
          classe="azul"
          :delay="'7000'"
        />
      </div>
      <MensagemUpgrade
        v-if="!carregandoEmpresas && !blUsuarioPro"
        :limite="listaEmpresas.length >= 100"
        :upgrade="listaEmpresas.length >= getAssinatura.qtde_empresa"
        :textoUpgrade="
          `Seu limite de <b>${getAssinatura.qtde_empresa}</b> ${
            getAssinatura.qtde_empresa == 1 ? 'empresa cadastrada' : 'empresas cadastradas'
          } foi atingido. </br> Atualize seu plano para aumentar o limite.`
        "
        textoLimite="Limite de cadastro máximo de empresas atingido. </br> Contrate o serviço de assessoria para cadastrar mais empresas.
          "
      />
    </div>
    <ModalEmpresa
      :titleModal="modalEmpresaTitulo"
      :limpaModalEmpresa="limpaModalEmpresa"
      @atualizaEmpresas="atualizarDados"
      :verificaCNPJ="verificaCNPJ"
      :formEmpresaModal="formEmpresaModal"
      :formEmpresaModalEditar="formEmpresaModalEditar"
    />
    <ModalCnae :cnaes="listaCnaes" />
    <ModalExcluirEmpresa
      :dadosEmpresaDelete="dadosEmpresaDelete"
      @atualizaEmpresas="atualizarDados"
    />
    <vCaptcha
      ref="refCaptcha"
      :cnpj_value="formEmpresa.cnpj"
      :id_empresa="formEmpresa.id"
      intIndexMensagem="1"
    ></vCaptcha>
  </div>
</template>

<!-- <script src="./empresas.js"> -->
<script>
import vCaptcha from "@/components/v-captcha/v-captcha.vue";
import vLoader from "@/components/Loader.vue";
import filtros from "@/store/modules/cenarioFiltros.js";
import stringFormatMixin from "@/mixins/stringFormatMixin";
import Paginacao from "@/components/Paginacao/Paginacao.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import ModalEmpresa from "@/components/ModalEmpresa/ModalEmpresa.vue";
import ModalCnae from "@/components/ModalEmpresa/ModalCnae.vue";
import ModalExcluirEmpresa from "@/components/ModalEmpresa/ModalExcluirEmpresa.vue";
import PaginaTitulo from "@/components/PaginaTitulo/PaginaTitulo.vue";
import CounterNcm from "@/modules/Pesquisa/components/Head/CounterNcm.vue";
import CenarioInput from "@/components/CenarioInput/CenarioInput.vue";
import TabelaEmpresas from "./TabelaEmpresas.vue";
import MensagemUpgrade from "@/components/MensagemUpgrade/MensagemUpgrade.vue";
import MensagemSemResultados from "@/components/MensagemSemResultados/MensagemSemResultados.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "empresas",
  components: {
    vCaptcha,
    vLoader,
    Paginacao,
    BotaoPadrao,
    ModalEmpresa,
    PaginaTitulo,
    CounterNcm,
    ModalCnae,
    ModalExcluirEmpresa,
    CenarioInput,
    TabelaEmpresas,
    MensagemUpgrade,
    MensagemSemResultados,
    LoadingPadraoContainer
  },
  mixins: [stringFormatMixin],
  inject: ["pushAlert"],
  data() {
    return {
      filtros,
      modalEmpresaTitulo: "Adicionar",
      listaEmpresas: [],
      carregandoEmpresas: false,
      campoPesquisa: "",
      limpaModalEmpresa: false,
      listaCnaes: [],
      dadosEmpresaDelete: {},
      formEmpresa: {},
      formEmpresaModal: {},
      formEmpresaModalEditar: {}
    };
  },
  created() {
    this.setListaEmpresas();
  },
  watch: {
    getListEmpresa: {
      deep: true,
      handler() {
        this.setListaEmpresas();
      }
    }
  },
  computed: {
    ...mapGetters("login", ["getAssinatura"]),
    ...mapGetters("empresa", ["getListEmpresa"]),
    ...mapGetters("auth", {
      blUsuarioPro: "getUsuarioPro"
    }),
    empresasFiltradas() {
      if (this.campoPesquisa == "") return this.listaEmpresas;
      let filtro = this.listaEmpresas.filter(
        f =>
          this.removerAcentos(f.nome.toLowerCase()).includes(
            this.removerAcentos(this.campoPesquisa.toLowerCase())
          ) ||
          this.removerAcentos(f.uf.toLowerCase()).includes(
            this.removerAcentos(this.campoPesquisa.toLowerCase())
          ) ||
          f.cnpj
            .replaceAll(".", "")
            .replaceAll("/", "")
            .includes(this.campoPesquisa.replaceAll(".", "").replaceAll("/", "")) ||
          f.empresa_cnae.find(p =>
            p.cnae.codigo
              .replaceAll(".", "")
              .replaceAll("/", "")
              .includes(this.campoPesquisa.replaceAll(".", "").replaceAll("/", ""))
          )
      );
      return filtro;
    }
  },
  methods: {
    ...mapActions("empresa", ["fetchListaEmpresas"]),
    inserirEmpresa() {
      if (this.listaEmpresas.length >= this.getAssinatura.qtde_empresa && !this.blUsuarioPro) {
        this.pushAlert("Limite de empresas atingido", "danger");
        return;
      }
      this.modalEmpresaTitulo = "Adicionar";
      this.limpaModalEmpresa = !this.limpaModalEmpresa;
      this.$root.$emit("bv::show::modal", `ModalEmpresaCadastro`);
    },
    deleteEmpresa(empresa) {
      if (this.blUsuarioPro) {
        this.pushAlert("Opção desabilitada na versão de testes", "danger");
        return;
      }
      this.dadosEmpresaDelete = empresa;
      this.$root.$emit("bv::show::modal", "ModalExcluirEmpresa");
    },
    editModal(empresa) {
      this.modalEmpresaTitulo = "Editar";
      this.formEmpresaModalEditar = {
        id: empresa.id,
        cnpj: empresa.cnpj,
        nome: empresa.nome,
        cnae: empresa.empresa_cnae,
        uf: empresa.id_uf,
        regime: empresa.id_regime_tributario
      };
      this.$root.$emit("bv::show::modal", `ModalEmpresaCadastro`);
    },
    atualizarDadosReceita(empresa) {
      if (this.blUsuarioPro) {
        this.pushAlert("Opção desabilitada na versão de testes", "danger");
        return;
      }

      this.editModal(empresa);
      this.verificaCNPJ(empresa);
    },
    setCnaes(empresa) {
      this.listaCnaes = empresa.empresa_cnae ? empresa.empresa_cnae : [];
      this.$root.$emit("bv::show::modal", "ModalCnae");
    },
    async atualizarDados() {
      this.carregandoEmpresas = true;
      await this.fetchListaEmpresas();
      this.carregandoEmpresas = false;
    },
    verificaCNPJ(form) {
      this.formEmpresa = form;
      this.$refs.refCaptcha.verificaCNPJ();
    },
    setListaEmpresas() {
      this.listaEmpresas = [
        ...this.getListEmpresa.map(empresa => {
          empresa.uf =
            empresa.id_uf != "0"
              ? this.filtros.estado_origem.valores.find(f => f.value == empresa.id_uf).sigla
              : "";
          return { ...empresa };
        })
      ];
    },
    setCnaeCnpj: function(arDados) {
      this.formEmpresaModal = {
        nome:
          arDados.nome_fantasia == "********" ? arDados.nome_empresarial : arDados.nome_fantasia,
        cnae: arDados.cnaes,
        uf: arDados.endereco_uf
      };
    }
  }
};
</script>

<style lang="scss">
.empresas-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.paginacao-container {
  width: 100%;
  display: flex;
  justify-content: center;
  max-width: 1155px;
  padding: 0 15px;
}
.search-wrapper {
  display: flex;
  align-items: center;
}
.input-empresas {
  width: 100%;
  margin-left: 10px;
}
.form-empresas {
  width: 100%;
  // padding-bottom: 15px;
  position: relative;
  max-width: 400px;
  input {
    width: 100%;
    float: left;
    border-radius: 2px;
    border: 1px solid rgba(60, 60, 60, 0.26);
    color: #333;
    background: #fdfdfd;
    padding: 5px 11px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    padding: 6px 10px;
    height: 32px;
    border-radius: 0;
  }
}
.form-wrapper-empresas {
  display: flex;
  justify-content: space-between;
  margin: 10px 0 15px 0;
  padding: 0 15px;
  width: 100%;
  max-width: 1155px;
}
.botão-modal-empresa {
  display: flex;
}
.corpo-modal-empresa-delete {
  text-align: center !important;
}
.header-excluir-modal-empresa {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.empresa-sem-resultado {
  width: 100%;
}
</style>
